<template>
    <div>
        <el-dialog title="创建用户" :visible.sync="dialogAdd.show"
                   @close="closeDialog()"
                   width="350px" height="400px"
                   :close-on-click-modal="false"
                   :append-to-body="true"
                   center id="addProjectBox">
            <el-form :model="formData" ref="ruleForm" :rules="rules"  label-width="80px">
              <el-form-item label="公司名" prop="companyName">
                <el-input v-model="formData.companyName" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="用户邮箱" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                    <el-input v-model="formData.phone"></el-input>
                </el-form-item>
              <el-form-item label="角色权限" prop="roleId">
                <el-select v-model="formData.roleId" placeholder="请选择角色权限">
                  <el-option label="超级管理员" value="12"></el-option>
                  <el-option label="普通用户" value="13"></el-option>
                </el-select>
                </el-form-item>
              <el-form-item label="用户名" prop="username">
                <el-input v-model="formData.username"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input type="password" show-password v-model="formData.password"></el-input>
              </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAdd.show = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'AddProject',
        props:{
            dialogAdd:Object //接受父组件传递给子组件的数据
        },
        data () {
//验证手机号的正则表达式
            let reg=/^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/
            //验证方法
            let validatorPhone = function (phone, value, callback) {
                if (value === '') {
                    callback(new Error('手机号不能为空'))
                } else if (!reg.test(value)) {
                    callback(new Error('手机号格式错误'))
                } else {
                    callback()
                }
            }
            return {
                formData:{
                    companyName:'陕西铁路工程职业技术学院',
                    email:'',
                    phone:'',
                    roleId:'',
                    username:'',
                    password:"",
                },
                rules: {
                    email: [
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    phone: [
                        { required: true,validator: validatorPhone, trigger: 'blur' },
                    ],
                    roleId: [
                        { required: true, message: '请选择角色权限', trigger: 'change' }
                    ],
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],

                }
            }
        },
        methods:{

            closeDialog(){
                this.dialogAdd.show = false;
                this.formData.companyName='陕西铁路工程职业技术学院'
                this.formData.email=''
                this.formData.phone=''
                this.formData.roleId=''
                this.formData.username=''
                this.formData.password=''
            },
            submitForm(ruleForm) {
                this.$refs[ruleForm].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/api/monitor/user/create',this.formData).then(res => {
                            if(res.data.status==200){
                                this.$message({
                                    type:"success",
                                    message:"添加用户信息成功",
                                    showClose: true
                                });
                                this.dialogAdd.show = false;
                                this.$emit('update'); //子组件使用$emit触发父组件自定义事件
                            }else{
                                this.$message.error(res.data.message)
                            }
                        });
                    } else {
                        return false;
                    }
                })
            }
        }
    }
</script>

<style>
  .el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
      -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%) !important;
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }

  .el-dialog__title {
    text-align: center;
    font-size: 18px;
    color: #fff;
  }


  .el-form-item{
    margin: 20px 0;
  }

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetting/AddUser.vue